interface IIlustrationVariant {
  title: string
  text: string
  color: string
} 

export const IlustrationVariants: Record<string, IIlustrationVariant> = {
  SALE: {
    title: 'Comprar',
    text: 'Ofrece a tu cliente la oportunidad para vivir con las mejores comisiones ',
    color: 'background-sale-color'
  },
  LEASE: {
    title: 'Rentar',
    text: 'Identificamos las propiedades con un precio de renta bajo en el mercado',
    color: 'background-lease-color'
  },
  EXPLORE: {
    title: 'Explorar',
    text: 'Busca libremente entre miles de propiedades',
    color: 'background-explore-color'
  }
}